"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.incrementCounter = void 0;
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const grafanaBasePrefix = "WebStories.Experiment";
/**
 * [WEB-1766] Add graphene metrics for an AB experiment that an exposure was logged on.
 * This was suggested by AB team for sanity checking due to over logging issue.
 * Graphene metrics are available in https://grafana-dashboard.sc-corp.net/d/WKuE6v44k/ab-experiment-exposure-log-tracker
 */
function incrementCounter(configId, pageTypeName, grafanaSuffix, dimensions) {
    const counterName = `${grafanaBasePrefix}.${configId}.${pageTypeName}.${grafanaSuffix}`;
    graphene_1.default.increment({ metricsName: counterName, dimensions, value: 1 });
}
exports.incrementCounter = incrementCounter;
//# sourceMappingURL=grafana.js.map